import classnames from 'classnames'

import { Icon } from '~/components/atoms/Icon/Icon'

import styles from './TrackingLozenge.module.css'

export enum TrackingLozengeState {
  Default = 'default',
  Collection = 'collection',
  Watchlist = 'watchlist',
}

export interface TrackingLozengeProps {
  state?: TrackingLozengeState
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  id?: string
  testID?: string
  title?: string
  className?: string
  'aria-label'?: string
}

export function TrackingLozenge({
  state = TrackingLozengeState.Default,
  onClick,
  disabled = false,
  id,
  testID,
  title,
  className,
  'aria-label': ariaLabel,
}: TrackingLozengeProps) {
  const isInCollection = state === TrackingLozengeState.Collection
  const isOnWatchlist = state === TrackingLozengeState.Watchlist
  const isTracked = isInCollection || isOnWatchlist

  return (
    <button
      type="button"
      id={id}
      data-testid={testID}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title={title}
      className={classnames(
        'TrackingLozenge',
        styles.lozenge,
        {
          [styles.collection]: isInCollection,
          [styles.watchlist]: isOnWatchlist,
        },
        className
      )}
    >
      <span className={styles.circle}>
        {isOnWatchlist ? (
          <Icon type="Heart" fill="#ffffff" />
        ) : (
          <Icon
            type="PortfolioChartIcon"
            width={10}
            height={10}
            fill={isInCollection ? '#ffffff' : '#0a0a0a'}
          />
        )}
      </span>
      <span className={styles.trailingIcon}>
        {isTracked ? (
          <>
            <span className={styles.tickIcon}>
              <Icon type="Tick" width={8} height={8} fill="#dddddd" />
            </span>
            <span className={styles.removeIcon}>
              <Icon type="CloseSmall" width={8} height={8} fill="#0a0a0a" />
            </span>
          </>
        ) : (
          <Icon type="Chevron" width={4} height={8} fill="#0a0a0a" />
        )}
      </span>
    </button>
  )
}
